/**
 * Institution Usage Service
 */

import { get } from '@/lib/api'
import { API_ROUTES } from '@/config/constants'

export interface InstitutionUsage {
  users: { total: number; activeLast30d: number; max: number | null }
  patients: { total: number; newLast30d: number }
  studies: {
    total: number
    thisMonth: number
    lastMonth: number
    max: number | null
  }
  reports: { total: number; last30d: number; signedLast30d: number }
  storage: { totalBytes: number; totalGb: number; maxGb: number | null }
  trend: Array<{ date: string; count: number }>
  lastActivity: {
    lastLoginAt: string | null
    lastStudyAt: string | null
    lastReportAt: string | null
  }
  plan: { code: string; name: string } | null
}

export const getInstitutionUsage = (institutionId: string): Promise<InstitutionUsage> =>
  get(API_ROUTES.INSTITUTIONS.USAGE(institutionId))
